import { ChartConfig } from "components/ui/chart";

import { CurrentTrendLegendMarker } from "./AnalyticsChartTooltip/LegendMarkers/CurrentTrendLegendMarker";
import { PreviousTrendLegendMarker } from "./AnalyticsChartTooltip/LegendMarkers/PreviousTrendLegendMarker";

export const chartConfig = {
  current: {
    icon: CurrentTrendLegendMarker,
    color: "var(--base-chart-1)",
  },
  previous: {
    icon: PreviousTrendLegendMarker,
    color: "var(--base-chart-3)",
  },
} satisfies ChartConfig


export type ChartData = {
    currentDate: string;
    currentValue: number;
    previousDate?: string;
    previousValue?: number;
}